import { render } from "./EmulateUser.vue?vue&type=template&id=187ff8f5&scoped=true"
import script from "./EmulateUser.vue?vue&type=script&lang=js"
export * from "./EmulateUser.vue?vue&type=script&lang=js"

import "./EmulateUser.vue?vue&type=style&index=0&id=187ff8f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187ff8f5"]])

export default __exports__